<template>
  <span class="relevance-badge" :class="badgeClass">
    {{ label }}
  </span>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  rank: number; // 1-indexed
}>();

const isGold = computed(() => props.rank === 1);
const isSilver = computed(() => props.rank === 2);
const isBronze = computed(() => props.rank === 3);

const label = computed(() => (props.rank <= 3 ? '関連度 高' : '関連度 中'));

const badgeClass = computed(() => ({
  'relevance-badge--gold': isGold.value,
  'relevance-badge--silver': isSilver.value,
  'relevance-badge--bronze': isBronze.value,
  'relevance-badge--medium': props.rank >= 4,
}));
</script>

<style lang="scss" scoped>
@import '~green/_variables.scss';

.relevance-badge {
  display: inline-block;
  padding: 2px 4px;
  min-width: 32px;
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  border-radius: 3px;
  white-space: nowrap;
  text-align: center;
  box-sizing: border-box;

  &--gold {
    background: #FFF3CD;
    color: #856404;
  }

  &--silver {
    background: #E9ECEF;
    color: #495057;
  }

  &--bronze {
    background: #FFE5D0;
    color: #8C4A00;
  }

  &--medium {
    background-color: #E8F5F1;
    color: #0BA780;
  }
}
</style>
